
import { computed, defineComponent, ref } from 'vue'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { useStore } from '@/composables/useStore'
import { variantSegmentationService } from '../../services'

export default defineComponent({
  name: 'CImportVariantSegmentations',
  components: {
    CImportBase,
    CImportInformation,
  },
  setup() {
    const store = useStore()
    const i18n = useI18nForVue2()

    const pageTitle = computed(() => `${i18n.t('ctx.import.variant-segmentations__page-title')}`)
    const uploadButtonLabel = computed(() => `${i18n.t('ctx.import.variant-segmentations__upload-button-label')}`)
    const reportWarning = computed(() => `${i18n.t('ctx.import.variant-segmentations__report-warning')}`)
    const informationTitle = computed(() => `${i18n.t('ctx.import.variant-segmentations__information-title')}`)
    const nbResultText = computed(() => `${i18n.t('ctx.import.variant-segmentations__information-result-number')}`)
    const exportText = computed(() => `${i18n.t('ctx.import.variant-segmentations__information-export-text')}`)

    const csvProperties = ref({
      name: 'variant-segmentations.csv',
      full_path: '/assets/csv/variant-segmentations.csv',
    })

    // Pas de compteur exposé par l'API : seul l'export est proposé dans le bloc d'information.
    const importInformation = ref({
      count: null,
      lastImportAt: null,
    })

    const descriptionLines = [
      `${i18n.t('ctx.import.common__description-line-1')}`,
      `${i18n.t('ctx.import.common__description-line-2')}`,
      `${i18n.t('ctx.import.common__description-line-3')}`,
      `${i18n.t('ctx.import.common__description-line-4')}`,
    ]

    const csvColumnDetails = computed(() => [
      {
        header: 'assortment_product_uid',
        format: 'VARCHAR',
        exampleValue: `${i18n.t('ctx.import.common__csv-column-details__example')}<code>INV6CFIRXF1S9LAWPHY</code>`,
        description: `<strong>${i18n.t('ctx.import.variant-segmentations__csv-column-details__assortment-product-uid-description-1')}</strong><br>${i18n.t('ctx.import.variant-segmentations__csv-column-details__assortment-product-uid-description-2')}`,
        mandatory: `${i18n.t('message.yes')}`,
      },
      {
        header: 'assortment_product_segments',
        format: 'VARCHAR',
        exampleValue: `${i18n.t('ctx.import.common__csv-column-details__example')}<br><code>seg1,seg2</code>`,
        description:
          `<strong>${i18n.t('ctx.import.variant-segmentations__csv-column-details__assortment-product-segments-description-1')}</strong>` +
          `<br>${i18n.t('ctx.import.variant-segmentations__csv-column-details__assortment-product-segments-description-2')}` +
          `<br>${i18n.t('ctx.import.variant-segmentations__csv-column-details__assortment-product-segments-description-3')}`,
        mandatory: `${i18n.t('message.yes')}`,
      },
    ])

    const distributorId = computed(() => store.getters.cooperativeId)
    const distributor = computed(() => store.getters.cooperative)

    const downloadCSV = () => variantSegmentationService.download(distributorId.value, distributor.value.name)

    return {
      variantSegmentationService,
      csvProperties,
      csvColumnDetails,
      descriptionLines,
      importInformation,
      pageTitle,
      uploadButtonLabel,
      reportWarning,
      informationTitle,
      nbResultText,
      exportText,
      downloadCSV,
    }
  },
})
